if (!window.Eurus.loadedScript.has('map.js')) {
  window.Eurus.loadedScript.add('map.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xMap', (data, embedUrl = '') => ({
        location: data,
        load() {
          const frame = this.$el.querySelector('iframe');
          if (!frame) return;
          const url = embedUrl || 'https://maps.google.com/maps?q=' + encodeURIComponent(this.location) + '&t=m&z=17&ie=UTF8&output=embed&iwloc=near';
          if (frame.getAttribute('src') !== url) frame.src = url;
        },
        loadMap(location) {
          this.location = location;
          this.load();
        },
        removeMap() {
          this.$el.querySelector('iframe')?.removeAttribute('src');
        }
      }));
    });
  });
}
